import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import { ParcelServiceProvider } from '~/services/shop/types';
import { getUrl } from '~/services/shop/utils';

export default function getParcelServicePoints(
    provider: ParcelServiceProvider,
    query: ShopTypes.ParcelServicePointQuery,
) {
    return shop
        .post(getUrl(`/checkout/parcelservicepoints/${provider}`), {
            json: query,
        })
        .json<ShopTypes.ParcelServicePointQueryResult>();
}
